/**
 * groupWorkspaceRelation模块接口列表
 */
import $http from '../utils/http' // 导入http中创建的axios实例

const groupWorkspaceRelation = {
  // 增加GroupWorkspaceRelation
  createGroupWorkspaceRelation (params) {
    return $http.post(`${global.API_URL}/sme/groupWorkspaceRelation/create`, params)
  },
  // 根据groupId和WorkspaceId删除GroupWorkspaceRelation模块
  deleteByGroupIdAndWorkspaceId (params) {
    return $http.post(`${global.API_URL}/sme/groupWorkspaceRelation/deleteByGroupIdAndWorkspaceId`, params)
  }
}

export default groupWorkspaceRelation



// WEBPACK FOOTER //
// ./src/api/groupWorkspaceRelation.js